
import styles from './index.module.scss'
import GoBack from "../components/GoBack"
import { useState, useContext, useMemo, useEffect, useRef } from "react"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import { EditOutlined, CloseOutlined } from '@ant-design/icons';
import { Button, Modal, Input, message } from 'antd';
import Iconfont from '@utils/Iconfont';
import PictureViewModal from '../components/PictureViewModal'
import API from "@api/api";
import Utils from '@utils/utils';
import useBatchListResult from "./useBatchListResult";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { DISPLAY_TYPE, BATCH_IMAGES_TYPE } from '@utils/CONST'
import PSAIModal from '@PSAIComponents/PSAIModal';
import { BatchImagesContext } from '../BatchImagesContext'
import RefListModal from '../components/RefListModal'
import GroupWrapLeft from './GroupWrapLeft'
import useDownloadSmartPageImags from './useDownloadSmartPageImags'



const notUploadUrl = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/batchProduceImages/notuploaded.png'

const ResultsPage = (props) => {
    const navigate = useNavigate()
    const { selectSkuId } = useContext(BatchImagesContext)
    const { isProCenter } = useLocation().state || {}
    const { projectId } = useParams()
    const modalRef = useRef(null)
    const [skuList, setSkuList] = useState([])
    const [editNameVisible, setEditNameVisible] = useState(false)
    const [nickName, setNickName] = useState('')
    const [projectName, setProjectName] = useState('')
    const [projectSerial, setProjectSerial] = useState('')
    const { dataList, groupedData, refresh, projectType } = useBatchListResult(projectId)
    const refListModalRef = useRef(null)

    const { downloadZip, loading, progress } = useDownloadSmartPageImags()

    // 生成页面左侧SKU列表
    const batchListSkuCoverList = () => {
        API.batchListSkuCoverList({
            projectId: projectId
        }).then(res => {
            if (res.code === 0) {
                setSkuList(res.data.skuDetailList || [])
                setProjectName(res.data.projectName || '')
                setProjectSerial(res.data.projectSerial || '')
                setNickName(res.data.projectName || '')
                setActiveSku(pre => !pre ? res.data.skuDetailList?.[0]?.skuId || '' : pre)
            } else if (res?.code == -5003) {
                navigate("/home/product/batchImages")
                message.error(res.message)
            }
        })
    }

    useEffect(() => {
        if (selectSkuId) {
            setTimeout(() => {
                handleScrollToSku(selectSkuId)
            }, 500)
        }
    }, [selectSkuId])


    useEffect(() => {
        if (dataList?.length == 0) return
        // 只有当所有项的 status 都为 succeeded 或 failed 时才设置已读
        const allCompleted = dataList.every(item =>
            item.status === 'succeeded' || item.status === 'failed'
        );
        if (allCompleted) {
            API.batchResetUnread({ projectId: projectId })
        }
        batchListSkuCoverList()
    }, [dataList])


    // 大图弹窗
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [item, setItem] = useState()
    const [taskId, setTaskId] = useState()
    const [modalOpenFlag, setModalOpenFlag] = useState(false)
    useEffect(() => {
        if (!isModalOpen) {
            setTaskId()
            setItem()
        }
    }, [isModalOpen])
    const handleCLick = (item) => {
        if (item.status != "succeeded") return
        setItem(item)
        setTaskId(item?.taskId)
    }
    useEffect(() => {
        if (item && taskId) {
            setIsModalOpen(true)
        }
    }, [item, taskId])


    // ============= 🔹 核心逻辑：滚动绑定 =============
    const groupRefs = useRef({}) // 保存右侧每个 skuId 对应的 div
    const rightBoxRef = useRef(null)
    const [activeSku, setActiveSku] = useState(null)

    const handleScrollToSku = (skuId) => {
        setActiveSku(skuId);
        const rightBox = rightBoxRef.current;
        const target = groupRefs.current[skuId];
        if (rightBox && target) {
            const offsetTop = target.offsetTop - rightBox.offsetTop;

            rightBox.scrollTo({
                top: offsetTop,
                behavior: "smooth",
            });
        }
    };

    // 选择这张图
    const handleChoose = (e, item) => {
        e.stopPropagation()
        if (item.status != "succeeded") return
        console.log('item', item)
        API.batchPickImage({
            taskId: item.taskId.split('_')[0],
            imageId: item?.results?.[0]?.id
        }).then(res => {
            if (res.code === 0) {
                refresh()
                batchListSkuCoverList()
            }
        })
    }

    // 再次生成
    const regenerateByTaskId = (taskId) => {
        API.regenerateByTaskId({
            taskId: taskId.split('_')[0]
        }).then(res => {
            if (res.code === 0) {
                refresh()
            } else message.error(res.message)
        })
    }

    // 重新编辑
    const reEditClick = (projectId, skuId, taskId) => {
        navigate(`/home/product/${projectId}/config?skuId=${skuId}&taskId=${taskId.split('_')[0]}`)
    }

    // 更新名称
    const updateNameOk = async () => {
        if (!nickName.trim()) { message.warning('请输入项目名'); return; }
        const saveRes = await API.batchUpdateProject({
            projectName: nickName.trim(),
            projectId
        })

        if (saveRes?.code === 0) {
            setEditNameVisible(false)
            setNickName('')
            batchListSkuCoverList()
        }
    }

    return (
        <>
            <div className={styles.ResultsPage}>
                <div className={styles.ResultsPageWrap}>
                    <div className={styles.GoBack}>

                        <GoBack onClick={() => isProCenter ? navigate('/home/myProject/batchImages') : navigate('/home/product/batchImages')} />

                        <span className={styles.TaskId}>项目ID：{projectSerial}</span>
                        <span className={styles.TaskTitle}>
                            {projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? 'AI试衣' :
                                projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? '换模特' :
                                    projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '商品智能堆叠' :
                                        projectType == BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ? '同款换色' :
                                            projectType == BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ? 'AI超清' :
                                                projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? '智能详情页' :
                                                    projectType == BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? '去水印' :
                                                        projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? '搭配上身' :
                                                            '换背景'}-{projectName}
                            <EditOutlined onClick={() => setEditNameVisible(true)} /></span>
                    </div>
                    <div className={styles.ResultsBox}>
                        <div className={`${styles.ResultsBoxLeft} _beauty_scrollbar`}>
                            {skuList?.map((item) => (
                                <div
                                    key={item.skuId}
                                    className={`${styles.ImageItem} ${activeSku === item.skuId ? styles.active : ""}`}
                                    onClick={() => handleScrollToSku(item.skuId)}
                                >
                                    <img src={Utils.getImgThumbnail(item.cover)} alt="" />
                                    {/* draft(0, "待发起"),
                                    pending(1, "排队中"),
                                    processing(2, "生成中"),
                                    completed(3, "已完成"),
                                    failed(4, "生成失败"); */}
                                    {
                                        (item?.pickedNum == 0 && item?.status === 3) && <span className={styles.pickedNumBtn}>待选图</span>
                                    }
                                </div>
                            ))}
                        </div>
                        <div ref={rightBoxRef} className={`${styles.ResultsBoxRight} _beauty_scrollbar`}>
                            {
                                groupedData?.map((item, index) => (
                                    <div key={item[0]?.skuId + index}
                                        ref={(el) => {
                                            const skuId = item[0]?.skuId;
                                            // 只在该 skuId 第一次出现时记录 ref
                                            if (el && !groupRefs.current[skuId]) {
                                                groupRefs.current[skuId] = el;
                                            }
                                        }}
                                        className={styles.groupWrap}>
                                        <GroupWrapLeft
                                            projectType={projectType}
                                            item={item}
                                            refListModalRef={refListModalRef}
                                            regenerateByTaskId={regenerateByTaskId}
                                            reEditClick={reEditClick} />
                                        <div className={styles.groupWrapRight}>
                                            {
                                                item.map((i, index) => (
                                                    i.status == 'started' || i.status == 'pending' ?
                                                        <div key={i?.taskId || index} className={styles.groupWrapRightItem}>
                                                            <img src={'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/picWaitngBg.png'} alt="" />
                                                            <span className={styles.spanText}>排队中...</span>
                                                        </div> :
                                                        i.status == 'processing' ?
                                                            <div key={i?.taskId || index} className={styles.groupWrapRightItem}>
                                                                <span className={styles.spanText}>生成中...</span>
                                                                <video
                                                                    src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/picProcessingBg.webm"
                                                                    autoPlay loop muted></video>
                                                            </div> :
                                                            i.status == 'failed' ?
                                                                <div key={i?.taskId || index} className={styles.groupWrapRightItem} >
                                                                    <span className={styles.spanText}>生成失败</span>
                                                                </div> :
                                                                i.status == 'succeeded' ?
                                                                    <div key={i?.taskId || index} onClick={() => handleCLick(i)}
                                                                        className={`${styles.groupWrapRightItem} ${styles.successItem}
                                                                         ${projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ||
                                                                                projectType == BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ||
                                                                                projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ?
                                                                                styles.groupWrapRightItemBatch : ''}`}>
                                                                        <div className={styles.successItemMask}>查看大图</div>
                                                                        <LazyLoadImage
                                                                            alt="example"
                                                                            effect="blur"
                                                                            src={Utils.getImgThumbnail(i.results?.[0]?.image)}
                                                                            placeholderSrc={Utils.getImgThumbnail(i?.results?.[0]?.image)}
                                                                        />
                                                                        {
                                                                            projectType != BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH &&
                                                                            <p className={`${styles.chooseBtn} ${i.results?.[0]?.picked ? styles.chooseBtnActive : ''}`}
                                                                                onClick={(e) => handleChoose(e, i)}>
                                                                                <Iconfont className={styles.Icon} type="icon-imgOutlined" />
                                                                                {i.results?.[0]?.picked ? '已选中' : '选这张'}
                                                                            </p>
                                                                        }
                                                                    </div> : null
                                                ))
                                            }

                                        </div>
                                        {
                                            projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH &&
                                            <div className={styles.smartPagesBtn}>
                                                <Button type="primary"
                                                    className={styles.smartPagesBtnItem}
                                                    loading={loading}
                                                    onClick={() => downloadZip(item, `PSAI_智能详情页${item[0]?.taskSerial}`)}>
                                                    下载详情页切图</Button>
                                            </div>
                                        }

                                    </div>
                                ))
                            }
                            {
                                projectType != BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH &&
                                <Button type="primary" className={styles.ViewSelectedBtn} onClick={() => navigate(`/home/product/${projectId}/selected`)}>查看已选图</Button>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                open={isModalOpen}
                onOk={() => setIsModalOpen(false)}
                footer={null}
                maskClosable={true}
                width={1600}
                destroyOnHidden
                onCancel={() => setIsModalOpen(false)}
                className='PictureViewModal'
                afterOpenChange={(open) => setModalOpenFlag(open)}
                closeIcon={<span
                    onClick={() => setIsModalOpen(false)}
                    className={styles.modalcloseIcon}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        position: 'absolute',
                        top: '-40px',
                        right: '-40px',
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(0,0,0,0.24)',
                        boxShadow: 'none',
                    }}>
                    <CloseOutlined /></span>}
            >
                <PictureViewModal
                    regenerateByTaskId={regenerateByTaskId} // 重新生成
                    reEditClick={reEditClick} // 重新编辑
                    handleChoose={handleChoose} // 选择图片
                    modalOpenFlag={modalOpenFlag}
                    displayType={DISPLAY_TYPE.PROJECT}
                    setProjectId={() => null}
                    ref={modalRef}
                    taskId={taskId}
                    setTaskId={setTaskId}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    item={item}
                    setItem={setItem}
                    groupedTasks={groupedData}
                    fetchProjectDetail={refresh} />
            </Modal>
            <PSAIModal
                title={'修改项目名'}
                maxWidth={400}
                okText={'确定'}
                open={editNameVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: false }}
                onCancel={() => setEditNameVisible(false)}
                onOk={() => updateNameOk()}
            >
                <div className={styles.editNameContent}>
                    <Input
                        value={nickName}
                        suffix={`${nickName.length}/40`}
                        onChange={(e) => setNickName(e.target.value)}
                        maxLength={40}
                        placeholder='请输入新名称' />
                </div>
            </PSAIModal>
            <RefListModal projectType={projectType} ref={refListModalRef} />
        </>

    )
}

export default ResultsPage
